import React, { useEffect } from 'react'
import {motion} from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/About.css'
import xm1 from '../assets/images/aboutmain.png'
import ab1 from '../assets/images/ab1.png'
import ab2 from '../assets/images/ab2.png'
import ab3 from '../assets/images/ab3.png'
import ab4 from '../assets/images/ab4.png'
import ab12 from '../assets/images/aba1.png'
import ab13 from '../assets/images/aba2.png'
import ab14 from '../assets/images/aba3.png'
import ab15 from '../assets/images/aba4.png'
import ab16 from '../assets/images/aba5.png'
import ab17 from '../assets/images/aba6.png'
import ab18 from '../assets/images/aba7.png'
import ab19 from '../assets/images/aba8.png'
import star from '../assets/images/star.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'


const About = () => {
  useEffect(()=>{
    AOS.init();
   
  })

  return (
    <div>
         <section className="main">
        <div className="main_sec">
          <h1>
     About Xceed 
        </h1>

          <p>Operate your business from a professional environment designed for credibility, focus, and flexibility. </p>

           <p>We're redefining what it means to work. Premium spaces <br />
designed for ambitious minds who demand excellence.</p>
        
              <button> Schedule a Tour    </button> &nbsp;
          <button style={{ background: "#0D0D0D", color: "white", opacity: 1 }}>
            View Pricing
          </button>
    
        </div>
      </section>

    
    <section style={{background:"#EEBD2B"}}>
      <div className='ab__div2'>
        <div className='ab__row1'>
          <div className='ab__col1'><h2>500+</h2><p>Active Members</p></div>
          <div className='ab__col1'><h2>15K</h2><p>Sq Ft Space</p></div>
          <div className='ab__col1'><h2>24/7</h2><p>Access Available</p></div>
          <div className='ab__col1'><h2>98%</h2><p>Satisfaction Rate</p></div>
        </div>
      </div>
    </section>
    

    <section>
       <div className='ab__div3'>
        <div className='ab__row3'>
          <div className='ab__col3'>
            
            <div className='ab__row3__sub'>
             <div className='ab__col3__sub'><img src={ab1} alt="" /></div> 
             <div className='ab__col3__sub' style={{marginTop:"3%"}}><img src={ab2} alt="" /></div>
            </div>
                        <div className='ab__row3__sub'>
             <div className='ab__col3__sub'><img src={ab3} alt="" /></div> 
             <div className='ab__col3__sub' style={{marginTop:"3%"}}><img src={ab4} alt="" /></div>
            </div>
            
            </div>
          
          
          
           <div className='ab__col3'>
            <h3>Our Story</h3>
            <h2>Built for Those Who Demand More</h2>
            <p>Founded in 2018, Xceed Office emerged from a simple belief: your
environment shapes your success. We saw professionals cramped in
uninspiring spaces and knew there had to be a better way. <br /> <br />
Today, we've created more than workspaces—we've built ecosystems where
innovation thrives. Every detail, from our ergonomic furniture to our community
events, is designed to elevate your work and expand your network.
</p>
<span style={{display:"flex",alignItems:"center",paddingTop:"8%"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"350px"}}/><h3>&nbsp; Since 2018</h3></span>
           </div>
        </div>
       </div>
    </section>

    <section>
      <div className='ab__div4'>
        <h3>The People</h3>
        <h2>Meet Our Leadership</h2>
        <p>Passionate professionals dedicated to creating the ultimate workspace experience.</p>
        <div className='ab__row4'>
          <div className='ab__col4a'>
            <div id='ab__box_b'>
              <h4>Sarah Mitchell</h4>
              <h5>Founder & CEO</h5>
            </div>
          </div>
          <div className='ab__col4b'>
             <div id='ab__box_b'>
              <h4>James Rodriguez</h4>
              <h5>Operations Director</h5>
            </div>
          </div>
          <div className='ab__col4c'>
             <div id='ab__box_b'>
              <h4>Emily Chen</h4>
              <h5>Community Manager</h5>
            </div>
          </div>
          <div className='ab__col4d'>
             <div id='ab__box_b'>
              <h4>Michael Thompson</h4>
              <h5>Facilities Manager</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
<br /><br />
    <section >
      <div className='ab__div5'>
        <div className='ab__row5'>
          <div className='ab__col5'>
            <h3>Why Choose Us</h3>
            <h2>Included Amenities</h2>
          </div>
          <div className='ab__col5'>
            <p>Everything you need to do your best work, included with every
membership.</p>
          </div>
        </div>
<br />

    <div className='ab__row6'>
      <div className='ab__col6'>
<img src={ab12} alt="" />
        <h3>High-Speed WiFi</h3>
        <p>Enterprise-grade internet with redundan
connections.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab13} alt="" />
   <h3>Pantry</h3>
        <p>Fully stocked kitchen with premium coffee and
snacks.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab14} alt="" />
       <h3>Printing</h3>
        <p>Professional printing and scanning equipment.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab15} alt="" />
        <h3>Lounge</h3>
        <p>Comfortable spaces for relaxation and networking.</p>
      </div>

    </div>
    <div className='ab__row6'>
      <div className='ab__col6'>
        <img src={ab16} alt="" />
        <h3>Helpdesk</h3>
        <p>On-site support team available during busines
hours.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab17} alt="" />
        <h3>Prayer Rooms</h3>
        <p>Private, quiet spaces for meditation and prayer.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab18} alt="" />
        <h3>Great Value</h3>
        <p>Flexible plans designed for every budget.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab19} alt="" />
        <h3>Beverages</h3>
        <p>Unlimited tea and coffee throughout your
workday.</p>
      </div>

    </div>


      </div>
    </section>
    <br /><br />
     <br /><br />
 <section className='location__lst'>
    <div className='location__div'>
        <h2>Ready to Elevate Your Work?</h2>
        <p>Join our community of innovators and experience the <br /> difference that a premium
workspace makes.</p>
<button>Get Started Today</button> <button style={{background:"black",color:"white"}}>Contact Us</button>
    </div>
 </section>
    </div>
  )
}

export default About